import * as React from "react";
import { useEffect } from "react";
import Login from "./auth/Login";
import { auth } from "./data/fire";
import { onAuthStateChanged } from "firebase/auth";
import { HashRouter, Route, Routes } from "react-router-dom";
// Auth
import LayoutAuth from "./layouts/LayoutAuth";
import LayoutAd1 from "./layouts/LayoutAd1";
import LayoutSplash from "./layouts/LayoutSplash"


import Error404 from "./Error404";
// siniestralidad
import Siniestralidad2025 from "./paginas/Admin/Sin/Siniestralidad2025";
// estadisticas
import Estádisticas2025 from "./paginas/Admin/Est/Estadisticas2025";
// Configuracion
import Parametrosform from "./paginas/Admin/Adm/Parametros";
import Modulosform from "./paginas/Admin/Adm/Modulos";
import Rolesform from "./paginas/Admin/Adm/Roles";
import Permisosform from "./paginas/Admin/Adm/Permisos";
import Proyectosform from "./paginas/Admin/Adm/Proyectos";
import Usuariosform from "./paginas/Admin/Adm/Usuarios";
import Configuracion from "./data/configuracion";
import Componente from "./paginas/Admin/Componente"
import apibig from "./components/Apibig" // Importa la configuración de Axios
import FormRoles from "./paginas/Admin/Adm/FormRoles";
import FormUsuarios from "./paginas/Admin/Adm/FormUsuarios";
import TransformacionView from "./paginas/Admin/Adm/transformacionView";

function App() {
  const [usuario, setUsuario] = React.useState(null);
  const [authState, setAuthState] = React.useState(null);
  const [autusuario, setAutUsuario] = React.useState([]);
  const [permisos, setPermisos] = React.useState(null);
  const [data] = React.useState({ correo: "", permisos: [] });
  const [rutasurl, setRutasurl] = React.useState([]);
  useEffect(() => {
    const email = autusuario.email;
    //  
    sessionStorage.setItem('data', JSON.stringify(data))
    const fetchroles = async () => {
      try {
        //  console.log({ proyecto: Configuracion.proyecto, emailusuario: autusuario.email,basededatos: Configuracion.basedatos })
        const response = await apibig.post("/api/permisos/getpermisosxusuario", { appid: Configuracion.proyecto, email: autusuario.email, basedatos: Configuracion.basedatos })

        if (response.data.permisos.length === 0 || response.data.correo === "") {
          sessionStorage.removeItem('data')
          setAuthState("login");

        } else {
          sessionStorage.removeItem('data')
          sessionStorage.setItem('data', JSON.stringify(response.data));
        }
      } catch (error) {
        console.error("Error al obtener usuarios:", error);
      } finally {
        // setCargando(false);
      }
    };
    fetchroles()
    //
    const fecthrutas = async () => {
      try {
        const proyecto = Configuracion.proyecto;
        const basedatos = Configuracion.basedatos;
        const response = await apibig.post("/api/permisos/geturlsxusuario", {
          appid: proyecto,
          email: email,
          basedatos: basedatos,
        });
        const data = response.data;

        setRutasurl(data);
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    };

    fecthrutas()
    const unSuscribirAuth = onAuthStateChanged(
      auth,
      async (authenticatedUser) => {
        if (authenticatedUser) {
          authenticatedUser.configuracion = Configuracion;
          setAutUsuario(authenticatedUser);
          setUsuario(authenticatedUser);
          let dataitem = JSON.parse(sessionStorage.getItem('data'));
          setPermisos(dataitem);
          setAuthState("Dashboard");
        } else {
          setUsuario(null);
          setAuthState("login");
        }
      }
    );
    const appName = Configuracion.aplicacion;
    document.title = `${appName} - Inicio`;
    return unSuscribirAuth;
  }, [usuario]);

  if (authState === null)
    return (
      <div className="font-bold text-center text-5xl py-[15vh]">
        Cargando...
      </div>
    );
  if (authState === "login")
    return <Login setAuthState={setAuthState} autusuario={autusuario} />;
  if (usuario)
    return (
      <div>
        <HashRouter>
          <Routes>
            <Route>
              <Route path="/auth/" element={<LayoutAuth />}>
                <Route index element={<LayoutAuth />} />
              </Route>
              <Route path="/" element={<LayoutSplash autusuario={autusuario} permisos={permisos} />}></Route>
              <Route path="/" element={<LayoutAd1 autusuario={autusuario} permisos={permisos} />}>
                {/* Configuracion */}
                <Route path="config/usuarios" element={<FormUsuarios autusuario={autusuario} />} />
                <Route path="config/roles" element={<FormRoles autusuario={autusuario} />} />
                <Route path="config/modulos" element={<Modulosform autusuario={autusuario} />} />
                <Route path="config/proyectos" element={<Proyectosform autusuario={autusuario} />} />

                <Route path="config/permisos" element={<Permisosform autusuario={autusuario} />} />
                {/* */}
                <Route path="componente/*" element={<Componente autusuario={autusuario} rutasurl={rutasurl} />} />
                <Route path="componente" element={<Error404 />}></Route>

                {/* sineistralidad*/}
                <Route path="siniestralidad/siniestralidad2025" element={<Siniestralidad2025 autusuario={autusuario} />} />
                {/* Estadisticas */}
                <Route path="estádisticas/estádisticas2025" element={<Estádisticas2025 autusuario={autusuario} />} />

                {/* Herramintas de transformaicion de data */}
                <Route path="transformacion" element={<TransformacionView autusuario={autusuario} />} />
              </Route>
            </Route>
            {/* Errores */}
            <Route path="*" element={<Error404 />}></Route>
          </Routes>
        </HashRouter>
      </div>
    );
}

export default App;
